import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: ({keys}) => ({
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        background: keys % 2 !== 0 && 'rgb(20, 27, 51)', 
        padding: 5
    }),
    groups: {
        color: 'hsla(0,0%,100%,.5)',
        fontSize: 16,
        width: 150,
        fontFamily: 'PT-sans, sans-serif',
    },
    balance: {
        color: '#fff',
        fontSize: 16,
        fontFamily: 'PT-sans, sans-serif', 
    }
}))

export {
    useStyles
}